// Golf Wouwse Plantage Course Data

export const courseData = {
  name: "Golf Wouwse Plantage",
  holes: [
    // De Bleekloop (Holes 1-9)
    { number: 1, par: 4, strokeIndex: 9, length: 274, course: "De Bleekloop" },
    { number: 2, par: 5, strokeIndex: 3, length: 435, course: "De Bleekloop" },
    { number: 3, par: 4, strokeIndex: 7, length: 297, course: "De Bleekloop" },
    { number: 4, par: 3, strokeIndex: 15, length: 132, course: "De Bleekloop" },
    { number: 5, par: 5, strokeIndex: 5, length: 417, course: "De Bleekloop" },
    { number: 6, par: 4, strokeIndex: 1, length: 327, course: "De Bleekloop" },
    { number: 7, par: 4, strokeIndex: 13, length: 262, course: "De Bleekloop" },
    { number: 8, par: 3, strokeIndex: 17, length: 109, course: "De Bleekloop" },
    { number: 9, par: 4, strokeIndex: 11, length: 302, course: "De Bleekloop" },
    
    // De Plantage (Holes 10-18)
    { number: 10, par: 4, strokeIndex: 18, length: 252, course: "De Plantage" },
    { number: 11, par: 4, strokeIndex: 10, length: 296, course: "De Plantage" },
    { number: 12, par: 3, strokeIndex: 14, length: 160, course: "De Plantage" },
    { number: 13, par: 5, strokeIndex: 6, length: 379, course: "De Plantage" },
    { number: 14, par: 4, strokeIndex: 4, length: 348, course: "De Plantage" },
    { number: 15, par: 5, strokeIndex: 2, length: 390, course: "De Plantage" },
    { number: 16, par: 3, strokeIndex: 16, length: 145, course: "De Plantage" },
    { number: 17, par: 4, strokeIndex: 12, length: 287, course: "De Plantage" },
    { number: 18, par: 4, strokeIndex: 8, length: 289, course: "De Plantage" },

    // Bergvliet (Season Finale, 18 holes)
    { number: 1, par: 3, strokeIndex: 5, course: "Bergvliet" },
    { number: 2, par: 4, strokeIndex: 17, course: "Bergvliet" },
    { number: 3, par: 5, strokeIndex: 13, course: "Bergvliet" },
    { number: 4, par: 3, strokeIndex: 11, course: "Bergvliet" },
    { number: 5, par: 4, strokeIndex: 9, course: "Bergvliet" },
    { number: 6, par: 3, strokeIndex: 15, course: "Bergvliet" },
    { number: 7, par: 5, strokeIndex: 3, course: "Bergvliet" },
    { number: 8, par: 4, strokeIndex: 7, course: "Bergvliet" },
    { number: 9, par: 5, strokeIndex: 1, course: "Bergvliet" },
    { number: 10, par: 4, strokeIndex: 6, course: "Bergvliet" },
    { number: 11, par: 3, strokeIndex: 18, course: "Bergvliet" },
    { number: 12, par: 4, strokeIndex: 4, course: "Bergvliet" },
    { number: 13, par: 4, strokeIndex: 10, course: "Bergvliet" },
    { number: 14, par: 5, strokeIndex: 14, course: "Bergvliet" },
    { number: 15, par: 3, strokeIndex: 2, course: "Bergvliet" },
    { number: 16, par: 5, strokeIndex: 12, course: "Bergvliet" },
    { number: 17, par: 4, strokeIndex: 8, course: "Bergvliet" },
    { number: 18, par: 3, strokeIndex: 16, course: "Bergvliet" }
  ]
};

// Bergvliet teebox options (Season Finale)
const bergvlietTeeboxes = {
  wit: { label: 'Wit', CR: 71.4, PAR: 71, SR: 137 },
  geel: { label: 'Geel', CR: 69.5, PAR: 71, SR: 131 },
  blauw: { label: 'Blauw', CR: 67.6, PAR: 71, SR: 121 },
  rood: { label: 'Rood', CR: 65.8, PAR: 71, SR: 110 },
  oranje: { label: 'Oranje', CR: 64.0, PAR: 71, SR: 107 },
};

export const getBergvlietTeeboxes = () => bergvlietTeeboxes;

export const getBergvlietCourseHandicap = (handicapIndex, teeboxColor) => {
  const teebox = bergvlietTeeboxes[teeboxColor];
  if (!teebox) return 0;
  return Math.round(handicapIndex * (teebox.SR / 113) + (teebox.CR - teebox.PAR));
};

// Official Handicap Tables for 9-hole Course Handicap (Baanhandicap)
// Based on GEEL (Yellow) tees - most common for men

const handicapTableBleekloop = {
  ranges: [
    [-4.0, -2.6, -2],
    [-2.5, -0.9, -1],
    [-0.8, 0.8, 0],
    [0.9, 2.5, 1],
    [2.6, 4.2, 2],
    [4.3, 5.9, 3],
    [6.0, 7.7, 4],
    [7.8, 9.4, 5],
    [9.5, 11.1, 6],
    [11.2, 12.8, 7],
    [12.9, 14.5, 8],
    [14.6, 16.2, 9],
    [16.3, 17.9, 10],
    [18.0, 19.6, 11],
    [19.7, 21.4, 12],
    [21.5, 23.1, 13],
    [23.2, 24.8, 14],
    [24.9, 26.5, 15],
    [26.6, 28.2, 16],
    [28.3, 29.9, 17],
    [30.0, 31.6, 18],
    [31.7, 33.3, 19],
    [33.4, 35.0, 20],
    [35.1, 36.8, 21],
    [36.9, 38.5, 22],
    [38.6, 40.2, 23],
    [40.3, 41.9, 24],
    [42.0, 43.6, 25],
    [43.7, 45.3, 26],
    [45.4, 47.0, 27],
    [47.1, 48.7, 28],
    [48.8, 50.5, 29],
    [50.6, 52.2, 30],
    [52.3, 53.9, 31],
    [54.0, 54.0, 32]
  ]
};

const handicapTablePlantage = {
  ranges: [
    [-4.0, -2.8, -2],
    [-2.7, -1.1, -1],
    [-1.0, 0.6, 0],
    [0.7, 2.4, 1],
    [2.5, 4.1, 2],
    [4.2, 5.8, 3],
    [5.9, 7.5, 4],
    [7.6, 9.3, 5],
    [9.4, 11.0, 6],
    [11.1, 12.7, 7],
    [12.8, 14.4, 8],
    [14.5, 16.2, 9],
    [16.3, 17.9, 10],
    [18.0, 19.6, 11],
    [19.7, 21.3, 12],
    [21.4, 23.1, 13],
    [23.2, 24.8, 14],
    [24.9, 26.5, 15],
    [26.6, 28.2, 16],
    [28.3, 30.0, 17],
    [30.1, 31.7, 18],
    [31.8, 33.4, 19],
    [33.5, 35.1, 20],
    [35.2, 36.9, 21],
    [37.0, 38.6, 22],
    [38.7, 40.3, 23],
    [40.4, 42.0, 24],
    [42.1, 43.8, 25],
    [43.9, 45.5, 26],
    [45.6, 47.2, 27],
    [47.3, 48.9, 28],
    [49.0, 50.7, 29],
    [50.8, 52.4, 30],
    [52.5, 54.0, 31]
  ]
};

// Helper functions
export const getHolesByCourse = (courseName) => {
  return courseData.holes.filter(hole => hole.course === courseName);
};

export const getCourseNames = () => {
  return ["De Bleekloop", "De Plantage"];
};

// Get course handicap from the official tables
export const getCourseHandicap = (playerHandicap, courseName) => {
  const table = courseName === "De Bleekloop" ? handicapTableBleekloop : handicapTablePlantage;
  
  for (let range of table.ranges) {
    if (playerHandicap >= range[0] && playerHandicap <= range[1]) {
      return range[2];
    }
  }
  
  // Fallback if handicap is outside table range
  return Math.round(playerHandicap / 2);
};

// Calculate which holes get strokes based on course handicap and stroke index
// For 9-hole courses, strokes are allocated within that 9-hole set
export const getStrokesForHole = (holeStrokeIndex, courseHandicap, courseName) => {
  // Get all holes for this course to determine relative difficulty within the round
  const courseHoles = getHolesByCourse(courseName);
  const strokeIndices = courseHoles.map(h => h.strokeIndex).sort((a, b) => a - b);
  const holesCount = courseName === 'Bergvliet' ? 18 : 9;

  if (courseHandicap > 0) {
    // Positive handicap: get strokes on the hardest holes
    // Get the Nth lowest stroke indices (where N = courseHandicap)
    const strokesToAllocate = Math.min(courseHandicap, holesCount);
    const cutoffIndex = strokesToAllocate - 1;
    const strokeCutoff = strokeIndices[cutoffIndex];

    // Check double strokes FIRST (courseHandicap > holesCount means some holes get 2 strokes)
    if (courseHandicap > holesCount) {
      const doubleStrokesCount = courseHandicap - holesCount;
      const doubleStrokeCutoff = strokeIndices[doubleStrokesCount - 1];
      if (holeStrokeIndex <= doubleStrokeCutoff) {
        return 2;
      }
    }

    // Then check single strokes
    if (holeStrokeIndex <= strokeCutoff) {
      return 1;
    }
  } else if (courseHandicap < 0) {
    // Plus handicap: give back strokes on easiest holes (highest SI)
    const giveBackCount = Math.abs(courseHandicap);
    const giveBackStartIndex = holesCount - giveBackCount;
    const giveBackCutoff = strokeIndices[giveBackStartIndex];
    if (holeStrokeIndex >= giveBackCutoff) {
      return -1;
    }
  }

  return 0;
};

// Calculate Stableford points
export const calculateStablefordPoints = (grossScore, par, strokes) => {
  const netScore = grossScore - strokes;
  const diff = par - netScore;
  
  // Stableford scoring:
  // 2+ over par = 0 points
  // 1 over par = 1 point
  // Par = 2 points
  // 1 under par (birdie) = 3 points
  // 2 under par (eagle) = 4 points
  // 3 under par (albatross) = 5 points
  
  if (diff >= 3) return 5;
  if (diff === 2) return 4;
  if (diff === 1) return 3;
  if (diff === 0) return 2;
  if (diff === -1) return 1;
  return 0; // 2 or more over par
};